import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [FooterComponent],
  exports: [FooterComponent],
})
export class SharedUiComponentsModule {}
